import FaceTwoTone from "@mui/icons-material/FaceTwoTone"
import { Avatar, IconButton } from "@mui/material"
import type { FC } from "react"

type Props = {
  alt: string
  fileId: string | null
  onClick(): void
}

export const AccountButton: FC<Props> = (props) => {
  const size = 32

  const src =
    props.fileId !== null && props.fileId.trim() !== ""
      ? `/api/images/${props.fileId}`  // サイズパラメータを削除
      : undefined

  return (
    <IconButton onClick={props.onClick}>
      <Avatar
        alt={props.alt}
        src={src}
        sx={{
          width: size,
          height: size,
          bgcolor: "transparent",
          color: "text.secondary",
        }}
      >
        <FaceTwoTone />
      </Avatar>
    </IconButton>
  )
}
